import { render } from "./extendView.vue?vue&type=template&id=765b0ff6&scoped=true"
import script from "./extendView.vue?vue&type=script&lang=js"
export * from "./extendView.vue?vue&type=script&lang=js"

import "./extendView.vue?vue&type=style&index=0&id=765b0ff6&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-765b0ff6"]])

export default __exports__